<template>
	<div>
		<div v-if="!responded" class="sections">
			<section>
				<h3>Ergebnis:</h3>
				<RadioGroup v-model="tookPlace" :options="tookPlaceOptions" stacked/>
			</section>
		</div>
		<TookPlace
			v-if="appointmentTookPlace"
			:message="message"
			class="mt-5"
			@processed="$emit('processed')"
			@responded="$emit('processed')"
		/>
		<DidNotTakePlace
			v-if="appointmentDidNotTakePlace"
			:message="message"
			class="mt-5"
			@processed="$emit('processed')"
		/>
	</div>
</template>

<script>
import RadioGroup from "@/vue/common/form/RadioGroup";
import TookPlace from "@/vue/communication/conversation/message/reply/post-appointment/ApplicantTookPlace";
import DidNotTakePlace from "@/vue/communication/conversation/message/reply/post-appointment/ApplicantDidNotTakePlace";

export default {

	components: {
		RadioGroup,
		TookPlace,
		DidNotTakePlace,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			tookPlace: undefined,
			responded: false,
		};
	},

	computed: {
		companyName ()
		{
			return this.message.customer.companyName;
		},
		tookPlaceOptions ()
		{
			return [
				{value: true, text: 'Der Termin hat stattgefunden'},
				{value: false, text: 'Der Termin hat nicht stattgefunden'},
			];
		},
		appointmentTookPlace ()
		{
			return this.tookPlace === true;
		},
		appointmentDidNotTakePlace ()
		{
			return this.tookPlace === false;
		},
	},
}
</script>
